import type { TUserRole } from '../types/common';

export const selectCurrencies = (state: RootState): string[] => state.base.avalableCurrencies;

export const selectUserRoles = (state: RootState): TUserRole[] => state.base.userRoles;
